import React, { Component, Fragment } from "react";
import {
  Row,
  Col,
  Card,
  Icon,
  Tag,
  Select,
  Radio,
  Checkbox,
  Divider,
  Slider
} from "antd";
import F from "../../../Functions";
import WizardFooter from "./wizard-footer";
import ClassicCar from "./images/new/classic_car.svg";
import RV from "./images/new/rv.svg";
import Boat from "./images/new/boat.svg";
import Motorcycle from "./images/new/motor_cycle.svg";
import Drone from "./images/new/drone.svg";
import GolfCart from "./images/new/golf_cart.svg";
import Watercraft from "./images/new/water_craft.svg";
import Snowmobile from "./images/new/snowmobile.svg";
import OffRoad from "./images/new/atv.svg";
import Other from "./images/new/other.svg";
import { Translate } from "react-translated";
import WizardPager from "../../../components/wizard-pager";
import SliderLayout from "./sliderlayout"

const Option = Select.Option;
const RadioGroup = Radio.Group;

class Step extends Component {
  render() {
    const { wizard, updateField, handleBlur, updateRadioBtnToggle } = this.props;

    let secondary_vehicles = [];
    if (
      wizard.secondary_vehicles !== null &&
      wizard.secondary_vehicles !== ""
    ) {
      secondary_vehicles = JSON.parse(wizard.secondary_vehicles);
    }

    const secondary_vehicles_list = [
      { name: "Classic Car", icon: ClassicCar },
      { name: "Motorcycle", icon: Motorcycle },
      { name: "RV", icon: RV },
      { name: "Boat", icon: Boat },
      { name: "Snowmobile", icon: Snowmobile },
      { name: "ATV", icon: OffRoad },
      { name: "Water Craft", icon: Watercraft },
      { name: "Golf Cart", icon: GolfCart },
      { name: "Drone", icon: Drone },
      { name: "Other", icon: Other }
    ];

    let rangeValues = [
      "",
      "$1-$10,000",
      "$10,001-$25,000",
      "$25,001-$50,000",
      "$50,001-$100,000",
      "$100,001-$150,000",
      "$150,001-$200,000",
      "$200,001-$250,000",
      "$250,001-$300,000",
      "$300,001-$350,000",
      "$350,001-$400,000",
      "$400,001-$450,000",
      "$450,001-$500,000",
      "$500,001-$600,000",
      "$600,001-$700,000",
      "$700,001-$800,000",
      "$800,001-$900,000",
      "$900,001-$1,000,000"
    ];
    let v1, v2;
    for (let i = 1; i < 21; i++) {
      v2 = 1000000 + 100000 * i;
      v1 = v2 - 100000 + 1;
      rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    }
    rangeValues.push("$3,000,001-$4,000,000");
    rangeValues.push("$4,000,001-$5,000,000");

    
    // let step = 500000;
    // for (let i = 1; i <= 18; i++) {
    //   v2 = 1000000 + step * i;
    //   v1 = v2 - step + 1;
    //   rangeValues.push(F.dollar_format(v1) + "-" + F.dollar_format(v2));
    // }

    let marks = {};
    for (let i = 0, rangeLen = rangeValues.length; i < rangeLen; i++) {
      marks[parseInt((i / (rangeLen - 1)) * 100, 10)] = {
        label:
          i === rangeValues.length - 1 ? rangeValues[i] : i === 0 ? "$0" : "",
        val: rangeValues[i]
      };
    }

    let secondary_vehicles_value = 0;
    if (wizard.secondary_vehicles_value !== "") {
      for (let x in marks) {
        if (marks[x].val === wizard.secondary_vehicles_value) {
          secondary_vehicles_value = parseInt(x, 10);
        }
      }
    }
    // Direct container reference to override App.js configuration
  const getCustomContainer = () => document.body;
    return (
      <Fragment>
        <div className="stepBody">
          <Card className="step2">
            <Card className="stepslayout">
              <h5 className="headingText">"How many vehicles do you own (not lease)?"</h5>
              <Select
                value={
                  wizard.primary_vehicles_num ? wizard.primary_vehicles_num : 0
                }
                style={{ width: 220 }}
                getPopupContainer={getCustomContainer}
                onChange={(value) => {
                  updateField("primary_vehicles_num", value);
                  if (!this.props.isExternalBFile) {
                    updateRadioBtnToggle();
                  }
                }
                }

              >


                {[...Array(11)].map((x, i) => (
                  <Option value={i} key={i}>
                    {i}
                  </Option>
                ))}
              </Select>
            </Card>
            <Card className="stepslayout" style={{ marginTop: 20 }}>
              <h5 className="headingText">“Do you own any recreational vehicles? (ATV, RV, Motorcycle, Boat) ?” <span className='asteriskIcon'>*</span></h5>
              <RadioGroup value={wizard.secondary_vehicles_toggle}
                onChange={(e) => {
                  updateField("secondary_vehicles_toggle", e.target.value);
                  if (!this.props.isExternalBFile) {
                    updateRadioBtnToggle();
                  }
                }}
              >
                <Radio value="1">Yes</Radio>
                <Radio value="0">No</Radio>
              </RadioGroup>
            </Card>



            <Card className="stepslayout" style={{ marginTop: 20 }}>
              {wizard.secondary_vehicles_toggle === "1" ? (
                <Fragment>
                  <h5 className="titleText2 headingText">"Please select all items you own :" <span className='asteriskIcon'>*</span></h5>
                  <Checkbox.Group
                    className=""
                    value={secondary_vehicles}
                    style={{ width: "100%" }}
                    onChange={(checkedList) => {
                      {
                        F.log("checkedList==>>", checkedList);
                        updateField(
                          "secondary_vehicles",
                          JSON.stringify(checkedList)
                        );
                        if (!this.props.isExternalBFile) {
                          updateRadioBtnToggle();
                        }
                      }
                    }}
                  >
                    <Row gutter={[16, 16]} style={{ display: 'flex', flexWrap: 'wrap' }}>
                      {secondary_vehicles_list.map((item, i) => {
                        return (
                          <Col key={i}
                            xs={24}
                            sm={12}
                            md={8}
                            lg={6}
                            className="checkbox_layout">
                            <Checkbox value={item.name} style={{ width: "100%" }}>
                              <div className="checkbox_items"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <div className="icon"
                                  style={{ flexShrink: 0 }}
                                >
                                  <img src={item.icon} alt={item.name}
                                    style={{
                                      objectFit: "contain",
                                    }}
                                  />
                                </div>
                                <div className="title" style={{ flexGrow: 1 }}>
                                  <Translate text={item.name} />
                                </div>
                              </div>
                            </Checkbox>
                          </Col>
                        );
                      })}
                    </Row>
                  </Checkbox.Group>
                  {wizard.secondary_vehicles && wizard.secondary_vehicles.length > 2 ? (<div className="insidecard" style={{ marginTop: 20 }}>
                    <h5>"What is the total approximate value of the secondary vehicles ?" <span className='asteriskIcon'>*</span></h5>
                    <div
                      style={{
                        width: "100%",
                        maxWidth: window.innerWidth > 768 ? "100%" : "400px",
                        margin: "0 auto",
                        padding: "10px",
                      }}
                    >
                      <SliderLayout
                        marks={marks}
                        value={secondary_vehicles_value}
                        name="secondary_vehicles_value"
                        updateField={updateField}
                        updateRadioBtnToggle={updateRadioBtnToggle}
                      />
                      <div
                        className="sliderValue center-align silder-align"
                      >
                        {wizard.secondary_vehicles_value || "$0"}
                      </div>
                    </div>


                  </div>) : null}
                </Fragment>
              ) : null}
            </Card>



            <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }} className='center'>
              <Col span={18} className='didyouKnowSection'>
                {/* <img src={require("./images/didyouKnow.png")} width={120} className='imgdid' /> */}
                <img src={require('./images/didYouKnowBulb.jpg')} width={40} alt='' />
                <h4>Did You Know</h4>
                <p className="textContent">“Primary & secondary vehicles have value and can be exposed as assets in a judgment.”</p>
              </Col>
            </Row>
            {/* <WizardFooter {...this.props} /> */}
          </Card>
          {/* <Card
            title={
              <Translate
                text={`"Do you own any secondary vehicles? (e.g. ATV's, RV's, Motorcycles, Boats, etc.)?"`}
              />
            }
            className="wizardBox"
            type="inner"
            style={{ textAlign: "center" }}
          >
           

            {wizard.secondary_vehicles_toggle === "1" ? (
              <div style={{ marginTop: 20 }}>
                <Card type="inner">
                  <Checkbox.Group
                    className="radioIcons"
                    value={secondary_vehicles}
                    style={{ width: "100%" }}
                    onChange={(checkedList) => {
                      {
                        F.log("checkedList==>>", checkedList);
                        updateField(
                          "secondary_vehicles",
                          JSON.stringify(checkedList)
                        );
                      }
                    }}
                  >
                    <Row gutter={16}>
                      {secondary_vehicles_list.map((item, i) => {
                        return (
                          <Col key={i} md={8} span={24}>
                            <Checkbox value={item.name}>
                              <div className="radioIconOption">
                                <div className="icon">
                                  <img src={item.icon} alt={item.name} />
                                </div>
                                <div className="title">
                                  <Translate text={item.name} />
                                </div>
                              </div>
                            </Checkbox>
                          </Col>
                        );
                      })}
                    </Row>
                  </Checkbox.Group>
                </Card>
                <Divider />
                <Card
                  title={
                    <Translate
                      text={`"Total value of the secondary vehicles?"`}
                    />
                  }
                  type="inner"
                >
                  <Slider
                    className="rangeSlider"
                    marks={marks}
                    step={null}
                    value={secondary_vehicles_value}
                    included={false}
                    tipFormatter={(val) => F.rangeSliderFormatter(val, marks)}
                    onChange={(val) =>
                      updateField(
                        "secondary_vehicles_value",
                        F.sliderValue(val, marks)
                      )
                    }
                  />
                  <div className="sliderValue center-align">
                    {wizard.secondary_vehicles_value || "$0"}
                  </div>
                </Card>
              </div>
            ) : null}
          </Card>
          <Card className="wizardBox center-align didYouKnowBox" type="inner">
            <h2>
              <Translate text={`DID YOU KNOW`} />
            </h2>
            <p>
              <Translate
                text={`Primary & secondary vehicles have value and can be exposed as assets in a judgment.`}
              />
            </p>
          </Card> */}
          {/* <WizardPager
            updateField={updateField}
            stepIndexPages={[2, 3]}
            wizardStepIndex={wizard.stepIndex}
          /> */}


        </div>
        <div className='stepFooter'>
          <WizardFooter {...this.props} />
        </div>
      </Fragment>
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step2_updated.js